import type { TrendPolarity } from '@/components/stats/trend-tone';

export type DashboardMetricKey =
  | 'attributedRevenue'
  | 'conversions'
  | 'roiAmount'
  | 'totalCommissions'
  | 'aov'
  | 'cpa';

/**
 * What a rise means on each dashboard metric. A dearer acquisition (CPA) is bad
 * news; commissions grow with sales as much as with cost, so they pass no verdict.
 */
export const DASHBOARD_METRIC_POLARITY: Record<DashboardMetricKey, TrendPolarity> = {
  attributedRevenue: 'higherIsBetter',
  conversions: 'higherIsBetter',
  roiAmount: 'higherIsBetter',
  aov: 'higherIsBetter',
  cpa: 'lowerIsBetter',
  totalCommissions: 'neutral',
};
